import React, { useState, useEffect, useRef } from 'react';
import { useCoolfoodContext } from './Store';
import { makeStyles } from '@material-ui/core/styles';
import { SvgIcon } from '@material-ui/core';
import person from '../images/person.gif';
import Typed from 'react-typed';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    // left: 'calc( 50% + 360px)',
    // transform: 'translateX(-50%)',
    // [theme.breakpoints.down('md')]: {
    left: 'auto',
    right: 10,
    transform: 'none',
    zIndex: 10000,
    // }
  },
  mainContainer: {
    position: 'relative',
    minHeight: 30,
    width: 100
  },
  close: {
    position: 'absolute',
    cursor: 'pointer',
    color: theme.green,
    top: 0,
    right: 0
  },
  bubbleContainer: {
    position: 'relative',
    height: '100%'
  },
  person: {
    width: 100,
    height: 'auto'
  },
  bubble: {
    fontSize: 14,
    position: 'absolute',
    bottom: -20,
    minHeight: 80,
    width: 400,
    right: 0,
    [theme.breakpoints.down('xs')]: {
      width: 300
    }
  }
}));

const CloseIcon = props => {
  return (
    <SvgIcon {...props}>
      {/* <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4 3.5-3.5-3.5-3.5 1.4-1.4 3.5 3.5 3.5-3.5 1.4 1.4-3.5 3.5 3.5 3.5z" /> */}
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </SvgIcon>
  );
};

const ShowIcon = props => {
  return (
    <SvgIcon {...props}>
      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
    </SvgIcon>
  );
};

export default function SmallScreen() {
  const classes = useStyles();

  const [globalState] = useCoolfoodContext();

  const [text, setText] = useState(['']);

  const [hide, setHide] = useState(false);

  const typedRef = useRef();

  useEffect(() => {
    setText([globalState.helpContent]);
    if (typedRef.current) {
      typedRef.current.reset();
    }
  }, [globalState.helpContent]);

  useEffect(() => {
    if (globalState.helpContent === text) {
      return;
    }
    // setHide(false);
  }, [globalState.helpContent, text]);

  return (
    <div className={classes.root}>
      <div className={classes.mainContainer}>
        {hide && (
          <CloseIcon className={classes.close} onClick={() => setHide(false)} />
        )}
        {!hide && (
          <>
            <ShowIcon className={classes.close} onClick={() => setHide(true)} />
            <div className={classes.bubbleContainer}>
              <div className={`speech-bubble-ds ${classes.bubble}`}>
                <Typed
                  typedRef={ref => (typedRef.current = ref)}
                  strings={text}
                  typeSpeed={20}
                />
                <div className="speech-bubble-ds-arrow" />
              </div>
            </div>
            <img className={classes.person} src={person} alt="helper" />
          </>
        )}
      </div>
    </div>
  );
}
